import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'components/ReactRouterDomLocalized';
import queryString from 'query-string';

import Footer from '../../components/Footer';
import HeaderWallet from 'components/wallet/HeaderWallet';
import PaymentOptionRadio from 'components/payment/PaymentOptionRadio';
import PaymentForm from 'components/payment/PaymentForm';

import {dt, nt} from 'l10n';

import {paymentWallet} from 'backend-helpers/payment';

import {getMemberWalletReplenish} from 'reducers/memberWalletReplenish';
import {getCurrentUser} from 'reducers/currentUser';

import 'sass/member/wallet/wallet.scss';
import 'sass/member/wallet/walletReplenish.scss';

const paymentPlans = [
    {value: 'wal10', price: 10, points: 100},
    {value: 'wal20', price: 20, points: 220},
    {value: 'wal50', price: 50, points: 600},
    {value: 'wal75', price: 75, points: 1000}
];

class WalletReplenish extends Component {
    constructor(props) {
        super(props);

        this.state = {
            t: 'wal10',
            returnPath: '/',
            needToReplenishUp: undefined,
            finalizeResult: false
        };

        this.onSuccess = this.onSuccess.bind(this);
    }

    componentDidMount() {
        this.loadDependentData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.loadDependentData(nextProps);

        let {virtualGift, currentUser} = nextProps;

        if (virtualGift && currentUser) {
            let needToReplenishUp = virtualGift.points - currentUser.counters.amount_wallet;
            if (needToReplenishUp > 0) {
                let preselectedPaymentPlan;
                for (preselectedPaymentPlan = 0; preselectedPaymentPlan < paymentPlans.length; preselectedPaymentPlan++) {
                    if (paymentPlans[preselectedPaymentPlan].points > needToReplenishUp) break;
                }
                this.setState({
                    needToReplenishUp: needToReplenishUp,
                    t: paymentPlans[preselectedPaymentPlan].value
                });
            }
        }

    }

    loadDependentData(props) {
        let {location, virtualGift} = props;

        let {return_path, gift_id} = queryString.parse(location.search);

        if (return_path) {
            this.setState({returnPath: return_path});
        }

        if (gift_id && (!virtualGift || virtualGift.id != gift_id)) {
            this.props.getMemberWalletReplenish(gift_id);
        }
    }

    onSuccess(response) {
        let {getCurrentUser} = this.props;
        getCurrentUser();

        let {finalizeResult} = response;

        this.setState({finalizeResult});

        if (!finalizeResult) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        let {currentUser, virtualGift} = this.props;

        let {t, returnPath, needToReplenishUp, finalizeResult} = this.state;

        let paymentFormAdditionalData = {t};
        if (virtualGift) paymentFormAdditionalData.finalizeGiftId = virtualGift.id;

        let notEnoughBlock;
        if (needToReplenishUp) {
            notEnoughBlock = (
                <div className="not-enough-tokens"
                    dangerouslySetInnerHTML={{__html:
                            dt('xxl',
                               'You need <strong>%1 tokens</strong> to buy %2',
                               needToReplenishUp,
                               virtualGift.name
                            )
                    }}
                />
            );
        }

        return (
            <div id="wrapper">
                <HeaderWallet location={location} replenish={true}/>{/* Let HeaderWallet update on location/locale change */}

                <div className="wallet-replenish">
                    <div className="content">
                        <div className="sub-header">
                            {notEnoughBlock}
                            <h1>{dt('xxl', 'Replenish your wallet')}</h1>
                        </div>


                        <div className="payment-options">
                            {paymentPlans.map((plan, index) =>
                                <PaymentOptionRadio
                                    value={plan.value}
                                    name={dt('xxl', "%1 tokens", plan.points)}
                                    price={plan.price}
                                    freePoints={plan.freePoints}
                                    checked={t === plan.value ? 'checked' : null}
                                    onSelect={(value) => this.setState({t: value})}
                                    key={index}
                                />
                            )}
                        </div>

                        <div className="help-text-block">
                            <p className="help-text" dangerouslySetInnerHTML={{__html: dt('xxl', 'Single payment, <em>without automated renewal</em>. You will be charged <strong>only</strong> once.')}}/>
                        </div>

                        <PaymentForm
                            currentUser={currentUser}
                            backendFn={paymentWallet}
                            additionalData={paymentFormAdditionalData}
                            onSuccess={this.onSuccess}
                            returnPath={returnPath}
                        />
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        virtualGift: state.memberWalletReplenish.virtualGift
    }),({
        getMemberWalletReplenish: getMemberWalletReplenish,
        getCurrentUser: getCurrentUser
    })
)(WalletReplenish)


// WEBPACK FOOTER //
// ./src/containers/member/WalletReplenish.js